/*
  Posterized - Add to cart on product cards (v61, 13-09-2026).
  Markup: snippets/pz-card-atc.liquid (size chips or a select + one button).
  Adds one unit of the chosen size through /cart/add.js. The Corner cart drawer
  opens on its own for every add, so nothing here opens a cart.
*/
(function () {
  'use strict';
  if (window.__pzCardAtc) return;
  window.__pzCardAtc = true;

  var ADD_URL = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  function setChoice(box, id, price) {
    var btn = box.querySelector('.pz-atc__btn');
    if (!btn) return;
    btn.setAttribute('data-v', id);
    var p = btn.querySelector('.pz-atc__p');
    if (p && price) p.textContent = '· ' + price;
  }

  function add(btn) {
    if (btn.classList.contains('is-busy')) return;
    var box = btn.closest('.pz-atc');
    var id = parseInt(btn.getAttribute('data-v'), 10);
    if (!box || !id) return;
    var label = btn.innerHTML;
    var old = box.querySelector('.pz-atc__err');
    if (old) old.parentNode.removeChild(old);
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add - please try again');
          return j;
        });
      })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = 'Added ✓';
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'pz_card_atc', { variant_id: id, page_type: (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType) || location.pathname });
          }
        } catch (e) {}
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.innerHTML = label;
        }, 1800);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.innerHTML = label;
        var m = document.createElement('p');
        m.className = 'pz-atc__err';
        m.setAttribute('role', 'alert');
        m.textContent = err && err.message ? err.message : 'Could not add - please try again';
        box.appendChild(m);
        setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 4000);
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var chip = t.closest('.pz-atc__size');
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      if (chip.disabled) return;
      var box = chip.closest('.pz-atc');
      var chips = box.querySelectorAll('.pz-atc__size');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i] === chip;
        chips[i].classList.toggle('is-on', on);
        chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      setChoice(box, chip.getAttribute('data-v'), chip.getAttribute('data-p'));
      return;
    }

    var btn = t.closest('.pz-atc__btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      add(btn);
      return;
    }

    /* a tap on the select must not fall through to the card link */
    if (t.closest('.pz-atc__select')) e.stopPropagation();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('pz-atc__select')) return;
    var opt = sel.options[sel.selectedIndex];
    setChoice(sel.closest('.pz-atc'), sel.value, opt && opt.getAttribute('data-p'));
  });
})();
